import {
  FETCH_PAGINATED_ORDERS,
  FETCH_ALL_ORDERS,
  RESET_ORDERS,
  RESET_CURRENT_ORDER,
  FETCH_ORDER_TYPES,
  FETCH_CURRENT_ORDER,
  FETCH_ORDER_EVENTS,
  ORDER_QUERY,
} from './../../mutation-types';

export default {
  [FETCH_PAGINATED_ORDERS](state, { orders, pagination }) {
    state.items = orders;
    state.pagination = pagination;
  },

  [FETCH_ALL_ORDERS](state, orders) {
    state.all = orders;
  },

  [RESET_ORDERS](state) {
    state.all = [];
    state.items = [];
    state.types = [];
    state.pagination = {
      currentPage: 1,
      lastPage: 0,
      limit: 5,
      totalCount: 0,
    };
    state.currentOrder = {};
  },

  [RESET_CURRENT_ORDER](state) {
    state.currentOrder = {};
  },

  [FETCH_ORDER_TYPES](state, orderTypes) {
    state.types = orderTypes;
  },

  [FETCH_CURRENT_ORDER](state, order) {
    state.currentOrder = order;
  },

  [FETCH_ORDER_EVENTS](state, events) {
    state.events = events;
  },

  [ORDER_QUERY](state, { page, limit, search }) {
    state.query.page = page;
    state.query.limit = limit;
    state.query.search = search;
    state.query.isSet = true;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/order/mutations.js